import { ContentState, EditorState, Modifier, convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';

export const modifyPastedText = (text: string, html: string | undefined, state: EditorState): boolean => {
  if (!html) {
    return false;
  }

  const contentBlock = htmlToDraft(html);
  if (!contentBlock) {
    return false;
  }

  const pastedContentState = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap);
  const fragment = pastedContentState.getBlockMap();
  const newContent = Modifier.replaceWithFragment(state.getCurrentContent(), state.getSelection(), fragment);
  return newContent;
};

export const convertContent = (editorState: EditorState): string => {
  const convertedContent = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    .replace(/font-family:[^;"]*/g, 'font-family:Inter')
    .replace(/background-color:[^;"]*/g, 'background-color:transparent');
  return convertedContent === '<p></p>\n' || convertedContent === '<p></p>' ? '' : convertedContent;
};
